// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toolbar__container-c4b036 {
  display: flex;
  justify-content: space-between;
  padding: 16px 16px;
  border-bottom: 1px solid var(--base-20);
  box-sizing: border-box;
}

.Toolbar__left-side-ad69f3 {
  display: flex;
  gap: 8px;
  align-items: center;
}

.Toolbar__rigth-side-c9d544 {
  display: flex;
  gap: 16px;
  align-items: center;
}

.Toolbar__menu-view-d731ec {
  min-width: 216px;
}

.Toolbar__container-compact-c5615e {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid var(--base-20);
  box-sizing: border-box;
  width: 360px;
}

.Toolbar__top-side-b58d10 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
}

.Toolbar__bottom-side-a9587a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
}

.Toolbar__arrows-e0b6d8 {
  display: flex;
  gap: 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/Toolbar/Toolbar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,uCAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;EACA,uCAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 16px;\n  border-bottom: 1px solid var(--base-20);\n  box-sizing: border-box;\n}\n\n.left-side {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.rigth-side {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.menu-view {\n  min-width: 216px;\n}\n\n.container-compact {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--base-20);\n  box-sizing: border-box;\n  width: 360px;\n}\n\n.top-side {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 72px;\n}\n\n.bottom-side {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 52px;\n}\n\n.arrows {\n  display: flex;\n  gap: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Toolbar__container-c4b036`,
	"left-side": `Toolbar__left-side-ad69f3`,
	"leftSide": `Toolbar__left-side-ad69f3`,
	"rigth-side": `Toolbar__rigth-side-c9d544`,
	"rigthSide": `Toolbar__rigth-side-c9d544`,
	"menu-view": `Toolbar__menu-view-d731ec`,
	"menuView": `Toolbar__menu-view-d731ec`,
	"container-compact": `Toolbar__container-compact-c5615e`,
	"containerCompact": `Toolbar__container-compact-c5615e`,
	"top-side": `Toolbar__top-side-b58d10`,
	"topSide": `Toolbar__top-side-b58d10`,
	"bottom-side": `Toolbar__bottom-side-a9587a`,
	"bottomSide": `Toolbar__bottom-side-a9587a`,
	"arrows": `Toolbar__arrows-e0b6d8`
};
module.exports = ___CSS_LOADER_EXPORT___;
